module.exports = __webpack_public_path__ + "img/icon_right.51b68ce4.svg";